import React, { PureComponent, Fragment } from 'react';
import { Progress, Table } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Panel from '../../../../../../shared/components/Panel';
import { getDefaultChartColors } from '../../../../../../shared/helpers';
import moment from "moment";

import{
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_generateRandomAPI,
	_getBuildingPhotos,
	_makeSlugifiedArr,
	_shouldShow,
	_urlToName,
	_formatUnitNumber
} from '../../../../../../shared/helpers/utils';
import TrashCanIcon from 'mdi-react/TrashCanIcon';
import { width } from '@material-ui/system';

const types = [0, 1, 2, 3, 4];

const _ellimanUnitStatus = (status) =>  {
	let eStatus = "Unclassified";
	const statusMap = {
		"sold" : "Closed",
		"resale" : "Closed",
		"not_yet_recorded" : "Signed",
		"in contract" : "Signed",
		"active" : "On Market",
		"bulk sold" : "Bulk Sales",
	}
	
	if(statusMap[status]) eStatus = statusMap[status];
	return eStatus;
	
}
	
class UnitList extends PureComponent {
  

  constructor(props) {
    super(props);
    this.state = {
      x: 0,
      y: 0,
	  deletedRow:[]
    };
  }
 
  handleClick(e,unit) {
  	
  	const { history, location } = this.props; 
  	const base_url = location.pathname.replace('analysis', 'units');	
  	history.push(`${base_url}?offering_bedrooms=${unit.search}`);

  }

  deleteUnitListRowHandler(value){
	this.setState((prevState) => ({
		deletedRow: [...prevState.deletedRow, `${JSON.stringify(value)}`],
	  }));
	  
	  
  }
  render() {
	const { t, unitData, title, editMode } = this.props;
    if(!unitData){
	    return null;
    }

	return (
			<Fragment>
			<h4 class="bold-text mt-1">{title ? title : "Unit List (Sorted by Status, Bedroom, and Price)"} </h4>
		    <Table responsive className="table--bordered dashboard__audience-table table--unit__matrix">
		      <thead>
			  	<tr>
					<th />
					<th className="th-sec unit-info" colSpan="8">Unit Information</th>
					<th className="th-sec status-info" colSpan="9">Status Information</th>
				</tr>
		        <tr>
				  <th className="th" style={{width:"100px"}} >Unit</th>
				  <th className="th">Bed</th>
		          <th className="th">Bath</th>
		          <th className="th">Int. SF</th>
		          <th className="th">Ext. SF</th>
		          {/* <th className="th">Monthly</th>
		          <th className="th">Monthly/SF</th> */}
				  <th className="th">OP</th>
				  <th className="th">Sale Type</th>
				  <th className="th">Status</th>
				  <th className="th">Ask Price</th>
				  <th className="th">Sale Price</th>
				  <th className="th">PPSF</th>
				  <th className="th">Signed</th>
				  <th className="th">Closed</th>
				{editMode ?   <th className="th delete_action">Action</th>:null}
				  {/* <th className="th">Listed</th>
				  <th className="th">DOM</th> */}
		        </tr>
				
		      </thead>
		      <tbody>
			
		        {[...unitData].filter((d, index) => !this.state.deletedRow.includes(`${JSON.stringify(d)}`)).map((d, index) => 
		    
			   <tr>
			  
		         	<td className="td all"  style={{width:"100px"}} >{_formatUnitNumber(d.address_2_normalized).replace("Unit", "")}</td>
					<td className="td">{d.bedrooms > -1 ? d.bedrooms === 0 ? 'Studio' : d.bedrooms+'' : '--'}</td>
					<td className="td">{d.baths > -1 ? d.baths+'' : '--'}</td>
					<td className="td">{_shouldShow(d.sq_ft) ? _formatNumber(d.sq_ft)+'' : '--'}</td>
					<td className="td">{_shouldShow(d.offering_exterior_sq_ft) ? <React.Fragment>{_formatNumber(d.offering_exterior_sq_ft)}</React.Fragment>  : `--`}</td>
					{/* <td className="td">{_shouldShow(d.offering_monthly_carrying_charges) ? `$${_formatNumber(d.offering_monthly_carrying_charges)}` : "--"}</td>
					<td className="td">{_shouldShow(d.offering_monthly_carrying_charges) && _shouldShow(d.sq_ft) ? `$${(((d.offering_monthly_carrying_charges/d.sq_ft)*100)/100).toFixed(2)}` : "--"}</td> */}
					<td className="td">{_shouldShow(d.offering_price) ? `$${_formatNumber(d.offering_price)}` : "--"}</td>
					<td className="td">{d.times_sold >= 2 ? "Resale" : "Sponsor"}</td>
					<td className="td">{d.elliman_status}</td>
					<td className="td">{_shouldShow(d.last_listed_sale_price_all) && d.last_listed_sale_price_all > 10000 ? `$${_formatNumber(d.last_listed_sale_price_all)}` : _shouldShow(d.offering_price) ? `$${_formatNumber(d.offering_price)}` : "--"}</td>
					<td className="td">{_shouldShow(d.last_sold_price) ? `$${_formatNumber(d.last_sold_price)}` : "--"}</td>
					<td className="td">{_shouldShow(d.last_sold_price) && _shouldShow(d.sq_ft) ? `$${_formatNumber(d.last_sold_price/d.sq_ft)}` : _shouldShow(d.sq_ft) && (_shouldShow(d.last_listed_sale_price_all) && d.last_listed_sale_price_all > 10000 ? `$${_formatNumber(d.last_listed_sale_price_all/d.sq_ft)}` : _shouldShow(d.offering_price) ? `$${_formatNumber(d.offering_price/d.sq_ft)}` : "--")}</td>
					<td className="td">{(["in contract", "sold", "not_yet_recorded"].indexOf(d.offering_status)>=0 || ["in contract", "sold", "not_yet_recorded"].indexOf(d.current_status)>=0 || d.times_sold >= 1) && d.current_status != "active" && parseInt(moment.unix(d.last_contract_date).format('YYYY')) > 1970 ? moment.unix(d.last_contract_date).format('MM/DD/YYYY') : "--"}</td>
					<td className="td">{parseInt(moment.unix(d.last_sold_date).format('YYYY')) > 1970 ? moment.unix(d.last_sold_date).format('MM/DD/YYYY') : "--"}</td>
					{/* <td className="td">{parseInt(moment.unix(d.last_listed_sale_date_all).format('YYYY')) > 1970 && (d.last_contract_date > d.last_listed_sale_date_all && ["in contract", "sold", "resale", "not_yet_recorded", "active"].indexOf(d.current_status) >=0) ? moment.unix(d.last_listed_sale_date_all).format('MM/DD/YYYY') : "--"}</td>
					<td className="td">{parseInt(moment.unix(d.last_listed_sale_date_all).format('YYYY')) > 1970 && d.last_contract_date > d.last_listed_sale_date_all && d.current_status == "active" ? `${_formatNumber(Math.round((d.last_contract_date - d.last_listed_sale_date_all)/60/60/24))}` : [ "sold", "not_yet_recorded", "resale"].indexOf(d.offering_status)>=0 ? "N/A" : "--"}</td> */}
		     {editMode ?  <tr className="td delete_action"><TrashCanIcon  size={20} style={{ cursor: "pointer", color: "black", width:"3rem" }} 
    onMouseEnter={(e) => (e.currentTarget.style.color = "red")}
    onMouseLeave={(e) => (e.currentTarget.style.color = "black")}
	onClick={() => this.deleteUnitListRowHandler(d)}
	/></tr>:null}
			    </tr>
		        )}
		      </tbody>
		    </Table>
			</Fragment>
	  )
	  
  }
}

export default UnitList;
